import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import CheckoutFooter from "../components/footer";
import AppConfig from "../../appConfig";
import axios from "../../axios";
import usePageTitle from "../pageTitle";
import {
  // Container,
  Box,
  Backdrop,
  Alert,
  Snackbar,
  CircularProgress,
  Typography,
  Paper,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  IconButton,
  Icon,
  Divider,
  Dialog,
  DialogContent,
  // DialogContentText,
  // DialogTitle,
  DialogActions,
  Button,
  Checkbox,
  TextField,
  MenuItem,
  Grid,
  Switch,
  Tooltip,
} from "@mui/material";

function InstagramApprovalPage() {
  const { ref, code } = useParams();
  const navigate = useNavigate();

  const [showLoading, setShowLoading] = useState(false);
  const [open, setOpen] = useState(false);
  const [errorMsg, setErrMsg] = useState("");
  const [severity, setSeverity] = useState("");
  const handleClose = () => {
    setOpen(false);
    setErrMsg("");
  };

  const [postData, setPostData] = useState(null);
  const [accessToken, setAccessToken] = useState(null);
  const [userInfo, setUserInfo] = useState({});
  const [contentInfo, setContentInfo] = useState({});
  const [comment, setComment] = useState(false);
  const [duet, setDuet] = useState(false);
  const [stitch, setStitch] = useState(false);
  const [caption, setCaption] = useState(null);
  const [privacyLevel, setPrivacyLevel] = useState(null);
  const [tosAgree, setTosAgree] = useState(false);
  const [disclose, setDisclose] = useState(false);
  const [brandedContent, setBrandedContent] = useState(false);
  const [personalContent, setPersonalContent] = useState(false);
  const [statusDialog, setStatusDialog] = useState(false);

  useEffect(() => {
    if (ref === null) {
      navigate("/error");
      return;
    }

    const fetchData = async () => {
      setShowLoading(true);
      await axios
        .get(`sm/instagram/approval/${ref}/${code}/init.json`)
        .then((result) => {
          console.log(result);
          setShowLoading(false);
          if (result.data.status === "success") {
            setPostData(result.data.data.postData);
            setCaption(result.data.data.postData.title);
            setAccessToken(result.data.data.accessToken);
            setUserInfo(result.data.data.userInfo);
            setContentInfo(result.data.data.contentInfo);
          } else {
            setSeverity("error");
            setErrMsg(result.data.data.message);
            setOpen(true);
          }
        })
        .catch(() => {
          setShowLoading(false);
          setSeverity("error");
          setErrMsg(
            `Unable to complete request. ${
              navigator.onLine
                ? ""
                : "Make sure you have an active internet connection"
            }`,
          );
          setOpen(true);
        });
    };

    fetchData();
  }, []);

  async function executePost() {
    // if (privacyLevel === null) {
    //   alert(`Please select who can see this post.`);
    //   return;
    // }

    // if (disclose) {
    //   if (!personalContent && !brandedContent) {
    //     alert(
    //       `You need to indicate if your content promotes yourself, a third party, or both.`
    //     );
    //     return;
    //   }
    // }

    // if (tosAgree === false) {
    //   alert(`Please agree to TikTok's content and usage policies.`);
    //   return;
    // }

    setShowLoading(true);
    const json = {
      reference: ref,
      access_token: accessToken,
      user_id: userInfo.user_id,
      caption: `${caption}`,
    };

    console.log(json);

    await axios
      .post("sm/instagram/approval/post", json)
      .then((result) => {
        setShowLoading(false);
        if (result.data.status === "success") {
          // setSeverity("success");
          setStatusDialog(true);
        } else {
          setSeverity("error");
          setErrMsg(result.data.data.message);
          setOpen(true);
        }
      })
      .catch(() => {
        setShowLoading(false);
        setSeverity("error");
        setErrMsg(
          `Unable to complete request. ${
            navigator.onLine
              ? ""
              : "Make sure you have an active internet connection"
          }`,
        );
        setOpen(true);
      });
  }

  //   useEffect(() => {
  //     if (brandedContent) {
  //       if (privacyLevel === "SELF_ONLY") {
  //         setPrivacyLevel("PUBLIC_TO_EVERYONE");
  //       }
  //       alert(
  //         "By selecting Branded Content, you cannot post your video as SELF_ONLY. Your privacy settings will be changed to PUBLIC_TO_EVERYONE"
  //       );
  //     }
  //   }, [brandedContent]);

  return (
    <>
      <Box mb={5}>
        <Backdrop
          sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
          open={showLoading}
          onClick={handleClose}
        >
          <CircularProgress color="inherit" />
        </Backdrop>
        <Snackbar
          open={open}
          autoHideDuration={6000}
          onClose={handleClose}
          anchorOrigin={{ vertical: "top", horizontal: "center" }}
        >
          <Alert
            onClose={handleClose}
            severity={severity}
            sx={{ width: "100%" }}
          >
            {errorMsg}
          </Alert>
        </Snackbar>
      </Box>
      <Dialog open={statusDialog}>
        <DialogContent>
          <Box align="center">
            <Box mb={3}>
              <Typography variant="h6">Post Successful!</Typography>
            </Box>
            <Icon color="success">check</Icon>
            <Box mt={3}>
              <Typography variant="subtitle2">
                Your post has been submitted. This may take a few minutes to
                reflect in your timeline.
              </Typography>
            </Box>
          </Box>
        </DialogContent>
      </Dialog>
      {postData !== null ? (
        <Box
          mt={10}
          sx={{ width: "100%", maxWidth: "800px", margin: "25px auto" }}
        >
          <Box>
            <h3>API INFORMATION RETURNED</h3>
            <div>
              <h4>Instagram Basic Info</h4>
              <pre>{JSON.stringify(userInfo, null, 4)}</pre>
            </div>
          </Box>
          <Grid container spacing={3}>
            <Grid item xs={12} md={6} lg={6}>
              <Box mt={1} align="center">
                {postData.media_type === "VIDEO" ? (
                  <Box
                    sx={{
                      padding: "10px",
                      background: "#D3D3D3",
                      webkitBorderRadius: "15px",
                      borderRadius: "15px",
                      overflow: "hidden",
                    }}
                  >
                    <iframe
                      title={postData.title}
                      type="text/html"
                      width="100%"
                      height="480"
                      src={`${postData.media}`}
                      frameBorder="0"
                      allowFullScreen
                    />
                  </Box>
                ) : (
                  <Paper elevation={0}>
                    <Box
                      p={2}
                      sx={{
                        padding: "10px",
                        background: "#D3D3D3",
                        webkitBorderRadius: "15px",
                        borderRadius: "15px",
                        overflow: "hidden",
                      }}
                    >
                      <img
                        src={`${postData.media}`}
                        alt={postData.title}
                        width="100%"
                        // width="320px"
                      />
                    </Box>
                  </Paper>
                )}
              </Box>
            </Grid>
            <Grid item xs={12} md={6} lg={6}>
              <Paper>
                <Box p={2}>
                  <Typography mb={3}>User Name: {userInfo.username}</Typography>
                  <Box mt={4}>
                    <TextField
                      fullWidth
                      multiline
                      label="Caption"
                      placeholder={caption}
                      onChange={(e) => setCaption(e.target.value)}
                    />
                  </Box>
                  <Box mt={5} align="center">
                    <Button
                      fullWidth
                      variant="contained"
                      onClick={() => executePost()}
                    >
                      POST CONTENT
                    </Button>
                  </Box>
                </Box>
              </Paper>
            </Grid>
          </Grid>
        </Box>
      ) : (
        <> </>
      )}
    </>
  );
}

export default InstagramApprovalPage;
